module.exports = __webpack_public_path__ + "img/lander-action-02-mobile.54fa2748.webp";